module.exports = __webpack_public_path__ + "assets/img/0ed5532a3da4078e80ced964f12ac6f8.png";